<template>
  <div v-if="quote.installments" class="cw-payment-plan">
    <div class="cw-payment-plan-first">
      <div><strong>1. Rate zum Vertragsbeginn</strong><p class="cw-small">{{ date(plan.firstDueDate) }}</p></div>
      <strong v-if="plan.firstCents !== null">{{ money(plan.firstCents) }}</strong>
    </div>
    <template v-if="plan.firstCents !== null">
      <p v-if="!compact" class="cw-small">{{ money(plan.rateCents) }} Mitgliedschaft + {{ money(quote.extrasCents) }} Zusatzpakete + {{ money(quote.feeCents) }} Aktivierung</p>
      <p v-if="plan.count > 1" class="cw-small">Danach {{ plan.count - 1 }} {{ plan.count === 2 ? 'Rate' : 'Raten' }} à {{ money(plan.rateCents) }}</p>
    </template>
    <p v-else class="cw-small">{{ plan.count }} Raten. {{ plan.discountCents ? 'Der Erneuerungsrabatt von ' + money(plan.discountCents) + ' ist im Vertragstotal enthalten. Die Verteilung auf die Raten ist noch zu klären.' : 'Die genaue Aufteilung auf die Raten ist wegen Rundungsdifferenzen noch zu klären.' }}</p>
    <p v-if="!compact" class="cw-small">{{ plan.info }}</p>
  </div>
</template>

<script>
import { money, date } from "./workspaceFormat"

export default {
  name: "ContractPaymentPlan",
  props: { quote: { type: Object, required: true }, compact: Boolean },
  computed: { plan() { return this.quote.installments } },
  methods: { money, date },
}
</script>
